export const environment={
    production:false,
    API_HOST:"https://api-hms-test.webiflysolutions.com/api"
}